module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "kbx-text-editor"
  }), _vm._v(" "), _c('toolbar')], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-67103f20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TextEditor/Main.vue
 ** module id = 851
 ** module chunks = 1
 **/